export enum LayoutFieldType {
  SETTINGS = 'settings',
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
  TOGGLE = 'toggle',
  SLIDER = 'slider',
  SPACING = 'spacing',
  MASK = 'mask',
  COLOR = 'color',
  SHADOW = 'shadow',
  BORDER = 'border',
  SELECT = 'select',
  PATTERN = 'pattern',
  // combined fields
  MEDIA = 'media',
  CARD = 'card',
  CELL = 'cell',
  DIALOG = 'dialog',
  CARDS = 'cards',
  DIALOG_CARDS = 'dialogCards',
  TEST_CARDS = 'testCards',
  TABLE = 'table',
  LIST_ITEM = 'listItem',
  LIST_COLLECTION = 'listCollection',
  LIST_TYPE = 'listType',
  CUSTOM = 'custom',
}

export enum LayoutBlockType {
  NONE = 'none',
  BLOCK1 = 'block1', // БЛОК картинка - текст
  BLOCK2 = 'block2', // БЛОК текст - картинка
  BLOCK3 = 'block3', // БЛОК текст - картинка
  BLOCK4 = 'block4', // БЛОК текст - картинка
  BLOCK5 = 'block5', // Новый тип блока
  BLOCK6 = 'block6', // Тести
  BLOCK7 = 'block7', // Списки
  BLOCK8 = 'block8', // Примечание
  BLOCK9 = 'block9', // Дівайдер (розмежувальна лінія)
  BLOCK10 = 'block10', // БЛОК только картинка
  // Child версії блоків
  BLOCK1_CHILD = 'block1Child',
  BLOCK2_CHILD = 'block2Child',
  BLOCK3_CHILD = 'block3Child',
  BLOCK4_CHILD = 'block4Child',
  BLOCK5_CHILD = 'block5Child',
  BLOCK6_CHILD = 'block6Child',
  BLOCK7_CHILD = 'block7Child',
  BLOCK8_CHILD = 'block8Child',
  BLOCK9_CHILD = 'block9Child',
  BLOCK10_CHILD = 'block10Child',
}

export enum TestType {
  SINGLE_CHOICE = 'singlechoice',
  MULTIPLE_CHOICE = 'multiplechoice',
  USER_INPUT = 'userinput',
}
